import { ThankYouBasketFragment } from '@generated/gql/graphql';

import { SmartMeterBooking } from './SmartMeterBooking';

interface SavingsProps {
  basket: Nullable<ThankYouBasketFragment>;
}

const Savings = ({ basket }: SavingsProps) => {
  if (!basket?.details.accountNumber || !basket.details.accountId) {
    return null;
  }

  return (
    <>
      <SmartMeterBooking basket={basket} />
    </>
  );
};

export { Savings };
